
<template>
  <v-container>
    <v-row>
      <v-col cols='12'>
        <last-deal></last-deal>
      </v-col>
      <v-col cols='12'>
        <hist-deal></hist-deal>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  components: {
    LastDeal: () => import('./lastDeal.vue'),
    histDeal: () => import('./histDeal.vue'),
  },
  computed: {
    ...mapState({
      oneProspect: state => state.Prospect.oneProspect,
    })
  },

}
</script>
